import React from 'react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Terms of Service | Newsmedia Association of India"
        description="Terms and Conditions of use for Newsmedia Association of India (NAI) website and services."
        keywords="Terms of Service, NAI Terms, User Agreement, Media Association Rules"
      />
      
      {/* Header */}
      <section className="bg-blue-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
          <p className="text-blue-100">Last Updated: May 2, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-blue max-w-none text-gray-700 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing or using the Newsmedia Association of India (NAI) website (naiindia.in), you agree to comply with and be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Use of Website</h2>
              <p>
                You agree to use the website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website. Prohibited behavior includes harassing or causing distress or inconvenience to any person, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within the website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, images, and software, is the property of NAI or its content suppliers and is protected by Indian and international copyright laws. You may not reproduce, distribute, or create derivative works from any part of this website without express written permission from NAI.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Membership and Registration</h2>
              <p>
                If you create an account or apply for membership on our website, you are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You agree to provide accurate and complete information during the registration process.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. User Content</h2>
              <p>
                By submitting news, reports, or other content to NAI, you grant us a non-exclusive, royalty-free, perpetual, and worldwide license to use, publish, and distribute such content in connection with our mission and services. You represent that you have the right to grant this license.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Limitation of Liability</h2>
              <p>
                NAI shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use the website or services, even if NAI has been advised of the possibility of such damages.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Chennai/Delhi, India.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
